import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

function AnimatedAccordionReveal({
  children,
  className = 'w-full',
  contentClassName = '',
  contentKey = 'default',
}) {
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isSettled, setIsSettled] = useState(false);

  useLayoutEffect(() => {
    if (!contentRef.current) return;

    const contentElement = contentRef.current;
    const updateContentHeight = () => {
      setContentHeight(contentElement.scrollHeight);
    };

    updateContentHeight();
    setIsOpen(false);
    setIsSettled(false);

    if (typeof ResizeObserver === 'undefined') return undefined;

    const observer = new ResizeObserver(updateContentHeight);
    observer.observe(contentElement);

    return () => observer.disconnect();
  }, [contentKey]);

  useEffect(() => {
    const frameId = window.requestAnimationFrame(() => {
      setIsOpen(true);
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [contentKey]);

  return (
    <div className={className}>
      <div
        className={!isSettled ? 'overflow-hidden' : ''}
        style={
          !isSettled
            ? { '--radix-accordion-content-height': `${contentHeight}px` }
            : undefined
        }
      >
        <div
          key={contentKey}
          className={isOpen && contentHeight > 0 ? 'animate-accordion-down' : 'h-0'}
          onAnimationEnd={() => setIsSettled(true)}
        >
          <div ref={contentRef} className={contentClassName}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AnimatedAccordionReveal;
